import { Component, computed, input, model, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';

interface ICountryCode {
  code: string;
  name: string;
  flag: string;
}

const COUNTRY_CODES: ICountryCode[] = [
  { code: '+51', name: 'Perú', flag: '🇵🇪' },
  { code: '+54', name: 'Argentina', flag: '🇦🇷' },
  { code: '+591', name: 'Bolivia', flag: '🇧🇴' },
  { code: '+55', name: 'Brasil', flag: '🇧🇷' },
  { code: '+56', name: 'Chile', flag: '🇨🇱' },
  { code: '+57', name: 'Colombia', flag: '🇨🇴' },
  { code: '+506', name: 'Costa Rica', flag: '🇨🇷' },
  { code: '+53', name: 'Cuba', flag: '🇨🇺' },
  { code: '+593', name: 'Ecuador', flag: '🇪🇨' },
  { code: '+503', name: 'El Salvador', flag: '🇸🇻' },
  { code: '+502', name: 'Guatemala', flag: '🇬🇹' },
  { code: '+504', name: 'Honduras', flag: '🇭🇳' },
  { code: '+52', name: 'México', flag: '🇲🇽' },
  { code: '+505', name: 'Nicaragua', flag: '🇳🇮' },
  { code: '+507', name: 'Panamá', flag: '🇵🇦' },
  { code: '+595', name: 'Paraguay', flag: '🇵🇾' },
  { code: '+1', name: 'EE.UU.', flag: '🇺🇸' },
  { code: '+598', name: 'Uruguay', flag: '🇺🇾' },
  { code: '+58', name: 'Venezuela', flag: '🇻🇪' },
  { code: '+34', name: 'España', flag: '🇪🇸' },
];

@Component({
  selector: 'app-whatsapp-phone-input',
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './whatsapp-phone-input.html',
})
export class WhatsAppPhoneInput {
  countryCodes = COUNTRY_CODES;
  numeroCelular = model<string>('');
  disabled = input<boolean>(false);

  selectedCountryCode = model<string>(COUNTRY_CODES[0].code);

  selectedFlag = computed(() => {
    const selected = this.countryCodes.find((c) => c.code === this.selectedCountryCode());
    return selected?.flag || '🇵🇪';
  });

  onPhoneNumberChange(value: string) {
    const digitsOnly = value.replace(/\D/g, '');
    this.numeroCelular.set(digitsOnly);
  }

  getFormattedNumber(): string {
    return `${this.selectedCountryCode()}${this.numeroCelular()}`;
  }
}
